import { loginUser } from "endpoints/auth";
import { useContext } from "react";
import { RequestLoader } from "context";
import { useMutation } from "react-query";
import { getRandomIntInclusive, getSlugName } from "helpers";
import { createSearchParams, useNavigate } from "react-router-dom";

const useSelfRegistration = (registrationData) => {
  const navigate = useNavigate();
  const data = {
    firstName: "",
    lastName: "",
    middleName: "",
    email: "",
    phoneNumber: registrationData?.accessNumber || "",
    phoneCode: registrationData?.phoneCode,
    gender: "MALE",
    dob: "",
    businessSlug: registrationData?.businessSlug,
  };
  const { isLoading, mutate: login } = useMutation((data) => loginUser(data));
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const handleSelfRegistration = (response) => {
    setRequestLoaderProgress(getRandomIntInclusive(20, 40));
    const sessionId = response?.data?.data?.id;
    if (!sessionId || !registrationData?.accessNumber) return;

    login(
      {
        phone_number: `${data.phoneNumber}`,
        phone_code: data.phoneCode,
        business_slug: getSlugName(),
      },
      {
        onSuccess: (response) => {
          navigate({
            pathname: "/login/otp",
            search: createSearchParams({
              session_id: response?.data?.data?.id,
              access_number: registrationData.accessNumber,
            }).toString(),
          });
        },
        onSettled: () => setRequestLoaderProgress(100),
      },
    );
  };

  return { data, handleSelfRegistration, isLoading };
};

export default useSelfRegistration;
